import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class OrganizationsService {
  constructor(private http: HttpClient) {}

  public fetchOrganizations(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/organization/list`
    return this.http.post(url, params)
  }
  public fetchOrganization(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/organization/${id}`
    return this.http.get(url, {})
  }

  public deleteOrganization(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/organization/${id}`
    return this.http.delete(url)
  }

  public createOrganization(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/organization`
    return this.http.post(url, params)
  }

  public updateOrganization(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/organization/${id}`
    return this.http.put(url, params)
  }
}
